import React from "react";

/**
 *
 * @param { string } title
 *
 * @returns Header HTML
 */
export default function Header({title, giftCard}) {

  /**
   * Get the icon based on the current state
   */
  const icon = giftCard && giftCard.id ? (
    <svg viewBox="0 0 20 20" className="gc__svg-filtered gc__giftcard-balance-icon gc__success-icon" focusable="false" aria-hidden="true"><path fillRule="evenodd" d="M0 10a10 10 0 1 0 20 0 10 10 0 0 0-20 0zm15.2-1.8a1 1 0 0 0-1.4-1.4L9 11.6 6.7 9.3a1 1 0 0 0-1.4 1.4l3 3c.4.4 1 .4 1.4 0l5.5-5.5z"></path></svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="gc__svg-filtered gc__giftcard-balance-icon">
      {/*<!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.-->*/}
      <path d="M512 32C547.3 32 576 60.65 576 96V128H0V96C0 60.65 28.65 32 64 32H512zM576 416C576 451.3 547.3 480 512 480H64C28.65 480 0 451.3 0 416V224H576V416zM112 352C103.2 352 96 359.2 96 368C96 376.8 103.2 384 112 384H176C184.8 384 192 376.8 192 368C192 359.2 184.8 352 176 352H112zM240 384H368C376.8 384 384 376.8 384 368C384 359.2 376.8 352 368 352H240C231.2 352 224 359.2 224 368C224 376.8 231.2 384 240 384z"/>
    </svg>
  );

  return (
    <div className="gc__balance_title">
      <div>
        <h1 className="gc__sub-heading ">
          {title}
        </h1>
      </div>
      <div>
        {icon}
      </div>
    </div>
  )
}
